import { Card, CardBody, Col, Input, Table } from "reactstrap";
import { TopSellingProductsTitle } from "../../../../../Constants/Constants";
import DashboardCommonHeader from "../../../../CommonComponents/DashboardCommonHeader/DashboardCommonHeader";
import ProductBody from "./ProductBody";

const TopSellingProducts = () => {
  return (
    <Col xl="7" className="box-col-7">
      <Card>
        <DashboardCommonHeader title={TopSellingProductsTitle} dropdownClass="dropdown-toggle" />
        <CardBody className="last-order px-0">
          <div className="table-responsive custom-scrollbar">
            <Table className="display" id="last-orders">
              <thead>
                <tr>
                  <th className="checkbox-checked">
                    <div className="form-check">
                      <Input type="checkbox" />
                    </div>
                  </th>
                  <th>Product Name</th>
                  <th>Date &amp; Time </th>
                  <th>Customer</th>
                  <th>Price </th>
                  <th>Status</th>
                  <th>Action </th>
                </tr>
              </thead>
              <ProductBody />
            </Table>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default TopSellingProducts;
